import React from "react";
import classNames from "classnames";

import { parseDateString } from "../../common/functions";

const RowSearch = ({ result }) => {
  const noteURL = `/notas/${parseDateString(result.date)}/${
    result.category.slug
  }/${result.slug}`;

  return (
    <div
      className={classNames("card", { "card-featured": result.first_image })}
    >
      {result.first_image && (
        <picture className="card-img-search">
          <img src={result.first_image} alt={result.title} />
        </picture>
      )}

      <div className="card-body">
        <div className="flex-upper">
          <div className="article-time">
            {result.category && (
              <span className="article-category">
                <i className="fas fa-caret-right"></i>
                <a
                  className="ml-1 mr-1 text-danger"
                  href={`/category/${result.category.slug}.html`}
                >
                  {result.category.category}
                </a>
              </span>
            )}
            <span className="time-pill">
              <i className="fas fa-clock"></i>
              {result.date}
            </span>
          </div>

          <div className="card-title title">
            <a href={noteURL}>{result.title}</a>
          </div>

          <div className="escucha-tiempo">
            <span className="listen-link">
              <i className="fab fa-twitter"></i>
              <b>
                <a
                  className="ml-1 author"
                  href={`/author/${result.author.slug}.html`}
                >
                  {result.author.name}
                </a>

                {result.author.email && (
                  <a href={`mailto:${result.author.email}`}>
                    {result.author.email}
                  </a>
                )}

                {result.author.twitter && (
                  <a href={result.author.twitter}>{result.author.twitter}</a>
                )}

                {result.author.image && (
                  <a href={result.author.image}>{result.author.image}</a>
                )}
              </b>
            </span>
          </div>
        </div>

        <div className="flex-lower">
          <div className="bookmark">
            <div className="pills pills-small">
              {result.tags && <Tags tags={result.tags} />}
              {result.point && result.point.coordinates && (
                <MapTag url={noteURL} />
              )}
            </div>
            <div className="dots">
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Tags = ({ tags }) =>
  tags.map((element, pos) => (
    <a
      key={`${element.tag}${pos}`}
      className="tag-pill tag-estados"
      href={`/tag/${element.tag.trim()}.html`}
    >
      {element.tag.trim()}
    </a>
  ));

const MapTag = ({ url }) => (
  <a className="text-danger mr-2" href={url}>
    <i className="fas fa-map-marker" />
  </a>
);

export default RowSearch;
